import { GENERATE_TYPE } from '../../../constants/constants'


/**
 * 軌道生成
 */
export interface FormTrajectoryRegiste {
  generateType: string;
  file: File|null;
  zipURI: string;
}
export const trajectoryRegisteInitInputs:FormTrajectoryRegiste = {
  generateType: GENERATE_TYPE[0].key,
  file: null,
  zipURI: ""
}


/**
 * 軌道生成結果
 */
export interface FormTrajectoryResultLinkType {
  id:number,
  name:string,
  disp:boolean
}
export interface FormTrajectoryResult {
  trajectory:string,
  trajectoryObj:number[][][],
  trajectoryStepNum:number,
  video:string,
  videoSecond:number,
  dispLinks: FormTrajectoryResultLinkType[];
  dispPos:number|null;
  sliderMin:number;
  sliderMax:number;
  curPos:{timeStr:string,step:number};
  goal:{timeStr:string,step:number}|null;
  action:string;
  armIds: string[];
  handIds: string[];
  fingertipIds: string[];
  classIds: string[];
}
export const trajectoryResultInitInputs:FormTrajectoryResult = {
  trajectory:"",
  trajectoryObj:[],
  trajectoryStepNum:0,
  video:"",
  videoSecond:0,
  dispLinks: [],
  dispPos:null,
  sliderMin:0,
  sliderMax:0,
  curPos:{timeStr:"",step:0},
  goal:null,
  action:"",
  armIds: [],
  handIds: [],
  fingertipIds: [],
  classIds: [],
}
